import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";

import { Header, TokensTable } from "../../components";
import { styles } from "../../styles/global";
import { getRequestMetadata } from "../../api";
import { BodyContainer } from "../../components/BaseComponents";

function Tokens(props) {
  const organizationId = getRequestMetadata().suki_organization_id;

  return (
    <>
      <Header headerTitle="Token Management" onDrawerToggle={props.onDrawerToggle} />
      <BodyContainer>
        <TokensTable organizationId={organizationId} />
      </BodyContainer>
    </>
  );
}

Tokens.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Tokens);
